import { useState, useEffect } from "react";
import pos1 from "../assets/pos1.png";
import pos2 from "../assets/pos2.png";
import pos3 from "../assets/pos3.png";

const HEADLINES = [
  "Powerful POS for Your Business",
  "Simplify Your Store Management",
  "Boost Sales with Armada POS",
  "All-in-One POS Solution",
]; // Example headlines, replace with your array

const IMAGES = [pos1, pos2, pos3];
const Hero = () => {
  const [headline, setHeadline] = useState("");
  const [image, setImage] = useState("");

  useEffect(() => {
    const idx = Math.floor(Math.random() * HEADLINES.length);
    setHeadline(HEADLINES[idx]);
    const idxImage = Math.floor(Math.random() * IMAGES.length);
    setImage(IMAGES[idxImage]);
  }, []);

  return (
    <section className="relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 py-16 md:py-24 grid md:grid-cols-2 gap-10 items-center">
        {/* Left content */}
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-blue-700">
            <span className="w-2 h-2 rounded-full bg-blue-600"></span>
            Armada POS
          </span>

          <h1 className="mt-4 text-3xl md:text-5xl font-extrabold leading-tight text-slate-900">
            {headline}
          </h1>

          <p className="mt-5 text-slate-700 text-lg">
            All-in-one POS for restaurants, cafés, retail, pharmacies, supermarkets, and chains.
            Offline-first, cloud-connected, multi-outlet ready — with owner dashboards and real-time insights.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="#signup"
              className="inline-flex items-center justify-center rounded-xl px-6 py-3 bg-blue-600 text-white font-semibold hover:bg-blue-700"
            >
              Start Free Trial
            </a>
            <a
              href="#features"
              className="inline-flex items-center justify-center rounded-xl px-6 py-3 border font-semibold hover:bg-slate-50"
            >
              See Features
            </a>
          </div>

          <p className="mt-4 text-sm text-slate-500">
            No credit card needed · Get set up in minutes · 24×7 support
          </p>
        </div>

        {/* Right image */}
        <div className="relative">
          <div className="aspect-[4/3] rounded-2xl bg-gradient-to-br from-blue-100 to-blue-200 border shadow-inner flex items-center justify-center">
            <img
              src={image}
              alt="Armada POS"
              className="h-20 opacity-80 w-full h-full object-cover rounded-2xl"
            />
          </div>

          <div className="absolute -bottom-4 -right-4 bg-white rounded-xl shadow p-4 border">
            <p className="text-xs font-semibold text-slate-600">Trusted in 30+ countries</p>
            <p className="text-xs text-slate-500">F&B · Retail - Chain venus</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
